import React, { useContext, useEffect, useState } from "react";
import { View, Text, Keyboard, Image, ActivityIndicator } from "react-native";
import { TouchableOpacity } from "react-native-gesture-handler";
import { NavigationProp } from "@react-navigation/native";
import { AppFontStyle } from "../../../../styles/AppFontStyle";
import { AppColors } from "../../../../utility/AppColors";
import CommonTextInputWeb from "../../../../common/CommonTextInputWeb";
import { toast } from "react-toastify";
import { ShowLoader } from "../../../../common/ShowLoader";
import { AuthContext } from "../../../../context/AuthContext";
import { base_url, endpoints } from "../../../../Api/configs";
import { DEVICE_SIZES } from "rn-responsive-styles";
import { deviceSize } from "rn-responsive-styles/lib/helpers";
import { register } from "../../../../services/authAPI";
import { AppImages } from "../../../../utility/AppImages";
import DateTimePickerModal from "../../WebScreens/Common/DateTimePickerModal";
import dayjs from "dayjs";
import moment from "moment";
import { validateUsername, validateEmailDomain } from "../../../../utility/Index";
import PasswordInfoTooltip from "./PasswordInfoTooltip";
import { TouchableWithoutFeedback } from "react-native";
import ImageComponent from "../../../../Components/ImageComponent";
interface SignUpFormProps {
  onClose: () => void;
  showModal: boolean;
  setShowModal: (value: boolean) => void;
  styles: any;
  email: string;
  setEmail: (email: string) => void;
  username: string;
  setUserName: (username: string) => void;
  password: string;
  setPassword: (password: string) => void;
  confirmPassword: string;
  setConfirmPassword: (confirmPassword: string) => void;
  referralCode: string;
  setReferralCode: (referralCode: string) => void;
  onCloseClick: () => void;
  navigation: NavigationProp<any>;
  showLoader: boolean;
  setShowLoader: (showLoader: boolean) => void;
  onSignUpSuccess: () => void;
  deviceSize: DEVICE_SIZES;
  setModalType: (type: string) => void;
  route: any;
  directReferrerId: string;
  isReferralEditable: boolean;
}

const SignUpForm: React.FC<SignUpFormProps> = ({
  showModal,
  setShowModal,
  onClose,
  styles,
  email,
  setEmail,
  username,
  setUserName,
  password,
  setPassword,
  confirmPassword,
  setConfirmPassword,
  referralCode,
  setReferralCode,
  onCloseClick,
  navigation,
  showLoader,
  setShowLoader,
  onSignUpSuccess,
  deviceSize,
  setModalType,
  route,
  directReferrerId,
  isReferralEditable,
}) => {
  // const { setModalType } = useContext(AuthContext);
  const [selectDate, setSelectDate] = useState("");
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [dateTimeInput, setDateTimeInput] = useState("");
  const [selectMonth, setSelectMonth] = useState(""); // For month
  const [selectDay, setSelectDay] = useState(""); // For day
  const [selectYear, setSelectYear] = useState(""); // For year
  const [daysInMonth, setDaysInMonth] = useState([]);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const months = moment.months(); // Array of months
  const [showPasswordTooltip, setShowPasswordTooltip] = useState(false);
  const [isPasswordValid, setIsPasswordValid] = useState(false);
  const years = Array.from(
    { length: 120 },
    (_, i) => new Date().getFullYear() - i
  ); // Array of years
  const handleCloseClick = () => {
    setShowModal(false);
    if (onClose) {
      onClose();
    }
  };
  const calculateDaysInMonth = (month, year) => {
    if (month && year) {
      const days = moment(`${year}-${month}`, "YYYY-MM").daysInMonth();
      return Array.from({ length: days }, (_, i) => i + 1);
    }
    return [];
  };
  console.log(referralCode,directReferrerId)
  useEffect(() => {
    if (selectYear && selectMonth && selectDay) {
      handleDateSelect(); // Automatically call when the full date is selected
    }
  }, [selectYear, selectMonth, selectDay]);
  // Effect to update days whenever month or year changes
  useEffect(() => {
    if (selectMonth && selectYear) {
      const days = calculateDaysInMonth(selectMonth, selectYear);
      setDaysInMonth(days);
    }
  }, [selectMonth, selectYear]);
  const handleDateSelect = () => {
    const date = `${selectDay}/${selectMonth}/${selectYear}`;
    const validDate = moment(date, "DD/MM/YYYY").isValid();
    if (!validDate) {
      alert("Please select a valid date.");
    } else {
      setSelectDate(moment(date, "DD/MM/YYYY").format("DD/MM/YYYY"));
    }
  };

  const validateEmail = (email: string): boolean => {
    const re = /\S+@\S+\.\S+/;
    return re.test(email);
  };
  function ageValidation() {
    if (selectDate !== "") {
      const today = moment();
      const birthDate = moment(selectDate, "DD/MM/YYYY");

      const age = today.diff(birthDate, "years");
      return age >= 18;
    }
  }
  const checkValidation = (): boolean => {
    if (email === "") {
      toast.error("Please Enter Email");
      return false;
    } else if (!validateEmail(email)) {
      toast.error("Please Enter a Valid Email");
      return false;
    } else if (!validateEmailDomain(email)) {
      toast.error("Email domain is not allowed. Please use a supported email provider.");
      return false;
    } else if (username === "") {
      toast.error("Please Enter Username");
      return false;
    } else if (!validateUsername(username)) {
      toast.error(
        "Please remove uppercase letters or special characters from username"
      );
      return false;
    } else if (password === "") {
      toast.error("Please Enter Password");
      return false;
    } else if (confirmPassword === "") {
      toast.error("Please Enter Confirm Password");
      return false;
    } else if (password !== confirmPassword) {
      toast.error("Password and Confirm Password are not same");
      return false;
    } else if (selectDate == "") {
      toast.error("Please select the birthdate");
      return false;
    } else if (!ageValidation()) {
      toast.error("Sorry, you must be at least 18 years old to register.");
      return false;
    } else if (referralCode == "") {
      toast.error("Referral code required");
      return false;
    }
    return true;
  };

  const userRegisterAPI = async () => {
    if (!isPasswordValid) {
      toast.error("Password does not meet the required conditions.");
      return;
    }
    if (!checkValidation()) {
      return;
    }

    setShowLoader(true);

    const bodyParams = {
      email,
      username,
      password,
      dob: selectDate,
      referralCode: referralCode,
      directReferrerId: directReferrerId
    };

    try {
      const data = await register(bodyParams);
      setShowLoader(false);

      if (data.statusCode === 200 || data.statusCode === 201) {
        toast.success("Registration Successful");
        document.cookie = `password=${confirmPassword}; path=/; max-age=86400;`;
        onSignUpSuccess();
      } else if (data.statusCode === 404 || data.statusCode === 403) {
        toast.error(data.body.error || "Enter Valid Refferal Code.");
      } else {
        toast.error(data.body.error || "Registration Failed");
      }
    } catch (error) {
      setShowLoader(false);
      toast.error(error.message);
    }
  };
  const validatePassword = (password) => {
    const hasNumber = /[0-9]/.test(password);
    const hasSpecialCharacter = /[!@#$%^&*(),.?":{}|<>]/.test(password);
    const hasUppercase = /[A-Z]/.test(password);
    const hasLowercase = /[a-z]/.test(password);
    const isAtLeast8Characters = password.length >= 8;

    const isValid =
      hasNumber &&
      hasSpecialCharacter &&
      hasUppercase &&
      hasLowercase &&
      isAtLeast8Characters;

    setIsPasswordValid(isValid);
  };

  const handlePasswordChange = (value) => {
    setPassword(value);
    validatePassword(value);
    setShowPasswordTooltip(true);
  };

  useEffect(() => {
    if (route?.params?.referralCode) {
      setReferralCode(route.params.referralCode);
    }
  }, []);

  
  return (
    <View
      style={{
        backgroundColor: AppColors.black_121212,
        width: deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE ? "25%" : "100%",
      }}
    >
      {/* Close Button
      <TouchableOpacity
        style={{ position: "absolute", top: 0, right: 0, padding: 10 }}
        onPress={handleCloseClick}
      >
        <Image
          source={AppImages.icCloseWhite}
          style={{ width: 36, height: 36 }}
        />
      </TouchableOpacity> */}
      <TouchableWithoutFeedback
        onPress={() => {
          setShowPasswordTooltip(false); // Hide tooltip when clicking outside
        }}
      >
        <View
          style={[
            {
              paddingHorizontal:
                deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                  ? "5%"
                  : "3%",
              paddingVertical:
                deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                  ? "5%"
                  : "3%",
              borderWidth: 1,
              borderColor: AppColors.white_B7C0CD,
              borderRadius: 8,
            },
            styles.bgImageWidth,
          ]}
        >
          <Text
            style={[
              AppFontStyle.BOLD_ANYBODY_32,
              {
                color: AppColors.white,
                marginBottom: 10,
              },
            ]}
          >
            Signup
          </Text>

          <CommonTextInputWeb
            placeholder="Email"
            mainStyle={[styles.inputStyle]}
            inputStyle={[
              AppFontStyle.REGULAR_ANYBODY_12,
              {
                paddingVertical: 10,
                paddingHorizontal: 10,
              },
            ]}
            prefixIconVisibility={false}
            onChangeText={setEmail}
            isPassword={false}
            value={email}
            onSubmitEditing={() => {
              Keyboard.dismiss();
            }}
            autoCapitalize="none"
            maxLength={50}
            isRequired={true}
          />

          <View
            style={{
              flexDirection: "row",
              justifyContent: "space-between",
              gap: 10,
            }}
          >
            {/* Year Picker */}
            <View style={{ flex: 0.33 }}>
              <select
                style={{
                  // width: 110,
                  height: 37,
                  marginBottom: 10,
                  borderRadius: 8,
                  background: AppColors.gray_4E555F,
                  fontFamily: "Anybody_400Regular",
                  fontSize: 12,
                  color: AppColors.white,
                }}
                value={selectYear}
                onChange={(e) => {
                  setSelectYear(e.target.value);
                  setSelectMonth(""); // Reset month and day if year changes
                  setSelectDay("");
                  setDaysInMonth([]);
                }}
              >
                <option
                  value=""
                  disabled
                  style={{
                    ...AppFontStyle.REGULAR_ANYBODY_12,
                    textAlign: "center",
                  }}
                >
                  Year
                </option>
                {years.map((year) => (
                  <option
                    key={year}
                    value={year}
                    style={{
                      ...AppFontStyle.REGULAR_ANYBODY_12,
                      textAlign: "center",
                    }}
                  >
                    {year}
                  </option>
                ))}
              </select>
            </View>

            {/* Month Picker */}
            <View style={{ flex: 0.33 }}>
              <select
                style={{
                  // width: 110,
                  height: 37,
                  marginBottom: 10,
                  borderRadius: 8,
                  background: AppColors.gray_4E555F,
                  fontFamily: "Anybody_400Regular",
                  fontSize: 12,
                  color: AppColors.white,
                }}
                value={selectMonth}
                onChange={(e) => setSelectMonth(e.target.value)}
                disabled={!selectYear} // Disable if year is not selected
              >
                <option
                  value=""
                  disabled
                  style={{
                    ...AppFontStyle.REGULAR_ANYBODY_12,
                    textAlign: "center",
                  }}
                >
                  Month
                </option>
                {months.map((month, index) => (
                  <option
                    key={index}
                    value={index + 1}
                    style={{
                      ...AppFontStyle.REGULAR_ANYBODY_12,
                      textAlign: "center",
                    }}
                  >
                    {month}
                  </option>
                ))}
              </select>
            </View>

            {/* Day Picker */}
            <View style={{ flex: 0.33 }}>
              <select
                style={{
                  // width: 110,
                  height: 37,
                  marginBottom: 10,
                  borderRadius: 8,
                  background: AppColors.gray_4E555F,
                  fontFamily: "Anybody_400Regular",
                  fontSize: 12,
                  color: AppColors.white,
                }}
                value={selectDay}
                onChange={(e) => setSelectDay(e.target.value)}
                disabled={!selectMonth || !selectYear} // Disable if month or year is not selected
              >
                <option
                  value=""
                  disabled
                  style={{
                    ...AppFontStyle.REGULAR_ANYBODY_12,
                    textAlign: "center",
                  }}
                >
                  Day
                </option>
                {daysInMonth.map((day) => (
                  <option
                    key={day}
                    value={day}
                    style={{
                      ...AppFontStyle.REGULAR_ANYBODY_12,
                      textAlign: "center",
                    }}
                  >
                    {day}
                  </option>
                ))}
              </select>
            </View>
          </View>

          <CommonTextInputWeb
            placeholder="UserName"
            mainStyle={[styles.inputStyle]}
            inputStyle={[
              AppFontStyle.REGULAR_ANYBODY_12,
              {
                paddingVertical: 10,
                paddingHorizontal: 10,
              },
            ]}
            prefixIconVisibility={false}
            onChangeText={setUserName}
            isPassword={false}
            value={username}
            onSubmitEditing={() => {
              Keyboard.dismiss();
            }}
            autoCapitalize="none"
            maxLength={50}
            isRequired={true}
          />

          <View style={{ position: "relative" }}>
            <CommonTextInputWeb
              placeholder="Password"
              mainStyle={[styles.inputStyle]}
              inputStyle={[
                AppFontStyle.REGULAR_ANYBODY_12,
                {
                  paddingVertical: 10,
                  paddingHorizontal: 10,
                },
              ]}
              prefixIconVisibility={false}
              onChangeText={handlePasswordChange}
              isPassword={true}
              value={password}
              secureTextEntry={showPassword ? false : true}
              onSubmitEditing={() => {
                Keyboard.dismiss();
              }}
              autoCapitalize="none"
              onPressEyeIcon={() => {
                setShowPassword(!showPassword);
              }}
              rightIcon={showPassword ? AppImages.icEye : AppImages.icEyeClose}
              showEyeIcon={true}
              maxLength={50}
              isRequired={true}
              rightIconStyle={{ width: 20, height: 20 }}
            />{" "}
            {showPasswordTooltip && (
              <PasswordInfoTooltip
                styles={styles}
                password={password}
                setShowPasswordTooltip={setShowPasswordTooltip}
                showPasswordTooltip={showPasswordTooltip}
              />
            )}
          </View>

          <CommonTextInputWeb
            placeholder="Confirm Password"
            mainStyle={[styles.inputStyle, { zIndex: -1 }]}
            inputStyle={[
              AppFontStyle.REGULAR_ANYBODY_12,
              {
                paddingVertical: 10,
                paddingHorizontal: 10,
              },
            ]}
            prefixIconVisibility={false}
            onChangeText={setConfirmPassword}
            isPassword={true}
            value={confirmPassword}
            secureTextEntry={showConfirmPassword ? false : true}
            onSubmitEditing={() => {
              Keyboard.dismiss();
              userRegisterAPI();
            }}
            autoCapitalize="none"
            onPressEyeIcon={() => {
              setShowConfirmPassword(!showConfirmPassword);
            }}
            rightIcon={
              showConfirmPassword ? AppImages.icEye : AppImages.icEyeClose
            }
            showEyeIcon={true}
            maxLength={50}
            isRequired={true}
            rightIconStyle={{ width: 20, height: 20 }}
          />
          <View style={{ position: "relative" }}>
            <CommonTextInputWeb
              placeholder="Referral Code"
              mainStyle={[styles.inputStyle, { zIndex: -1 }]}
              inputStyle={[
                AppFontStyle.REGULAR_ANYBODY_12,
                {
                  paddingVertical: 10,
                  paddingHorizontal: 10,
                },
              ]}
              prefixIconVisibility={false}
              onChangeText={setReferralCode}
              isPassword={false}
              value={referralCode}
              onSubmitEditing={() => {
                Keyboard.dismiss();
              }}
              autoCapitalize="none"
              maxLength={50}
              isRequired={true}
              editable={isReferralEditable}
            />
          </View>
          <View style={{ zIndex: -1 }}>
            <TouchableOpacity
              style={{
                justifyContent: "center",
                alignItems: "center",
                backgroundColor: AppColors.appViolentColor_6D08C3,
                borderRadius: 32,
                marginTop: 10,
                paddingVertical: 16,
                marginHorizontal: "20%",
              }}
              onPress={userRegisterAPI}
              disabled={showLoader}
            >
              {showLoader ? (
                <ActivityIndicator color={AppColors.white} />
              ) : (
                <Text style={[AppFontStyle.BOLD_ANYBODY_14]}>Sign up</Text>
              )}
            </TouchableOpacity>
          </View>
          <View
            style={{
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
              marginVertical: 20,
            }}
          >
            <Text
              style={[
                AppFontStyle.REGULAR_ANYBODY_12,
                {
                  color: "white",
                },
              ]}
            >
              Have an Account?{" "}
            </Text>
            <TouchableOpacity
              onPress={() => {
                setModalType("login");
              }}
              style={{ cursor: "pointer" }}
            >
              <Text
                style={[
                  AppFontStyle.BOLD_ANYBODY_14,
                  {
                    color: "white",
                  },
                ]}
              >
                {" "}
                Sign In{" "}
              </Text>
            </TouchableOpacity>
          </View>
          {/* <TouchableOpacity
            style={[
              styles.inputStyle,
              {
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
                gap: 10,
                borderRadius: 8,
                padding: 2,
              },
            ]}
          >
            <ImageComponent
              url={AppImages.icGoogleLogo}
              style={{
                width: 38,
                height: 38,
              }}
            />
            <Text
              style={[
                AppFontStyle.REGULAR_ANYBODY_14,
                { color: AppColors.white },
              ]}
            >
              Signup with Google
            </Text>
          </TouchableOpacity>
          <TouchableOpacity
            style={[
              styles.inputStyle,
              {
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
                gap: 10,
                borderRadius: 8,
                padding: 2,
              },
            ]}
          >
            <ImageComponent
              url={AppImages.icAppleLogo}
              style={{
                width: 32,
                height: 38,
              }}
            />
            <Text
              style={[
                AppFontStyle.REGULAR_ANYBODY_14,
                { color: AppColors.white },
              ]}
            >
              Signup with Apple
            </Text>
          </TouchableOpacity>
          <TouchableOpacity
            style={[
              styles.inputStyle,
              {
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
                gap: 10,
                borderRadius: 8,
                padding: 2,
              },
            ]}
          >
            <ImageComponent
              url={AppImages.icStreamLogo}
              style={{
                width: 38,
                height: 38,
              }}
            />
            <Text
              style={[
                AppFontStyle.REGULAR_ANYBODY_14,
                { color: AppColors.white },
              ]}
            >
              Signup with Stream
            </Text>
          </TouchableOpacity> */}

          <Text
            style={[
              deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                ? AppFontStyle.REGULAR_ANYBODY_10
                : deviceSize === DEVICE_SIZES.LG ||
                  deviceSize === DEVICE_SIZES.MD
                ? AppFontStyle.REGULAR_ANYBODY_16
                : AppFontStyle.REGULAR_ANYBODY_14,
              {
                color: AppColors.white,
                marginBottom: 10,
                marginTop: 8,
                textAlign: "center",
                textDecorationLine: "underline",
              },
            ]}
          >
            By signing up, you agree to our Privacy Policy and Terms of Service.
          </Text>
        </View>
      </TouchableWithoutFeedback>
    </View>
  );
};

export default SignUpForm;
